import clientAPI from "./apiclient.config";
import qs from 'qs';
import {environment} from "@/config";

const baseURL = window.location.protocol + '//' + window.location.host + environment.VUE_APP_AUTHORIZATION_URL;
const baseOrchURL = window.location.protocol + '//' + window.location.host + environment.VUE_APP_ORCH_API;
const baseQrCodeURL = window.location.protocol + '//' + window.location.host + environment.VUE_APP_QR_CODE_AUTHORIZATION_URL;

export default {
  abort() {
    return clientAPI().post(baseURL + '/cancel');
  },

  login(user) {
    console.log("auth.service login");

    let config = {
      headers: {
        'InfoCert-Correlation-ID': user.transactionId
      }
    }

    const data = {
      username: user.username,
      password: user.password,
      sessionId: user.transactionId,
      authCode: user.authCode,
      elapsed: user.elapsed
    }
    return clientAPI().post(baseURL, qs.stringify(data), config);
  },

  qrLogin(user) {
    console.log("auth.service qrLogin");
    let config = {
      headers: {
        'InfoCert-Correlation-ID': user.sessionId
      }
    }
    const data = {
      sessionId: user.sessionId,
      authCode: user.authCode
    }
    return clientAPI().post(baseQrCodeURL, qs.stringify(data), config);
  },

  getSPData(transactionId) {
    console.log("auth.service getSPData");
    let config = {
      headers: {
        'InfoCert-Correlation-ID': transactionId
      }
    }
    const url = baseURL + "/api/metadata?transactionId=" + transactionId;
    return clientAPI().get(url, config);
  },

  callback() {
    console.log("auth.service callback");
    const oauth2Url = baseURL + '/oauth2'
    return clientAPI(oauth2Url).get("/callback", {});
  },

  logout() {
    sessionStorage && sessionStorage.removeItem("user")
  },

  requestData(transactionId) {
    console.log("auth.service requestData");

    let config = {
      headers: {
        'InfoCert-Correlation-ID': transactionId
      }
    }

    const url = baseOrchURL + "transaction/" + transactionId + "/request-data"

    console.log("auth.service url: " + url);

    let result = clientAPI().get(url, config);

    console.log("auth.service requestData result: " + result);

    return result;
  }
};
